import { cn } from "@/lib/utils";
import type { ReactNode } from "react";
import { GrainLowOverlay } from "./grain-low-overlay";

/** Matches DevTopbar: solid greige-400 fill with the SVG Grain Low overlay on top. */
export const GREIGE_GRAIN_SURFACE_CLASS = "relative bg-greige-400";

type TGreigeGrainSurfaceProps = {
	className?: string;
	children?: ReactNode;
	contentClassName?: string;
};

/** Shared greige paper + grain treatment used by the landing nav header and page shells. */
export function GreigeGrainSurface({ className, children, contentClassName }: TGreigeGrainSurfaceProps) {
	return (
		<div className={cn(GREIGE_GRAIN_SURFACE_CLASS, className)}>
			<GrainLowOverlay />
			{children ? <div className={cn("relative z-[1]", contentClassName)}>{children}</div> : null}
		</div>
	);
}
